import { translateKey } from '../../../../../translate';
import { FormParagraph } from '../../../../elements/common';
import { FormLabel } from '../../../../elements/forms/FormLabel';
import { HorizontalFormGroupRead } from '../../../../elements/forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from '../../../../elements/forms/InputContainer';
import { DisplayIcd10 } from './Icd10/DisplayIcd10';

interface IDisplayWorkingDiagnosis {
    diagnosisConclusion: string | null;
    diagnosisConsiderationIcd10: string | null;
    thesaurusTermDate: string | null;
    thesaurusTermId: string | null;
}

export function DisplayWorkingDiagnosis(props: IDisplayWorkingDiagnosis) {
    return (
        <>
            {(props.diagnosisConsiderationIcd10 || props.diagnosisConclusion) && (
                <HorizontalFormGroupRead>
                    <FormLabel>{translateKey('diagnosis.workingDiagnosis')}</FormLabel>
                    <InputContainer>
                        <FormParagraph>
                            {props.diagnosisConsiderationIcd10 || props.thesaurusTermId ? (
                                <DisplayIcd10
                                    icd10Code={props.diagnosisConsiderationIcd10}
                                    thesaurusTermDate={props.thesaurusTermDate}
                                    thesaurusTermId={props.thesaurusTermId}
                                />
                            ) : (
                                props.diagnosisConclusion
                            )}
                        </FormParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}
        </>
    );
}
